import z from 'zod';
/**
 * DR-4456: a review flag on the published AD / SB / QEC status pack — see `StatusPackWarning`.
 * One definition shared by the three `*-events-ready` envelopes.
 */
const statusPackWarningSchema = z.discriminatedUnion('code', [
    z.looseObject({
        code: z.literal('csn-below-older-pack'),
        documentId: z.string(),
        reconstructedDocumentId: z.string(),
        headerCsn: z.number(),
        olderDocumentId: z.string(),
        olderReconstructedDocumentId: z.string(),
        olderDate: z.string(),
        olderHeaderCsn: z.number(),
    }),
]);
// Additive and OPTIONAL — absent when the published pack raises no flag. `.catch(undefined)`: the
// producer validates and then ships its own unparsed payload, so a malformed entry degrades the
// whole list to `undefined` on the CONSUMER side instead of failing the parse and dropping the pack.
export const statusPackWarningsSchema = z.array(statusPackWarningSchema).optional().catch(undefined);
//# sourceMappingURL=status-pack-warning.schema.js.map